/* ============================================================
   PLASMA MARINO — Theme JavaScript
   ============================================================ */

(function() {
  'use strict';

  // ---------- Cart Drawer ----------
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer-overlay');
  const cartToggle = document.querySelectorAll('[data-cart-toggle]');
  const cartClose = document.querySelector('.cart-drawer__close');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  cartToggle.forEach(function(btn) { btn.addEventListener('click', openCart); });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ---------- Mobile Menu ----------
  const mobileToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function() {
      mobileMenu.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded',
        mobileMenu.classList.contains('is-open'));
    });
  }

  // ---------- Email Popup ----------
  const emailPopup = document.querySelector('.email-popup-overlay');
  const emailClose = document.querySelector('.email-popup__close');

  if (emailPopup && !sessionStorage.getItem('pm_popup_closed')) {
    setTimeout(function() {
      emailPopup.classList.add('is-open');
    }, 5000);
  }
  if (emailClose) {
    emailClose.addEventListener('click', function() {
      emailPopup.classList.remove('is-open');
      sessionStorage.setItem('pm_popup_closed', '1');
    });
  }

  // ---------- Add to Cart (AJAX) ----------
  document.addEventListener('click', function(e) {
    var addBtn = e.target.closest('[data-add-to-cart]');
    if (!addBtn) return;
    e.preventDefault();

    var variantId = addBtn.getAttribute('data-variant-id');
    var qty = parseInt(addBtn.getAttribute('data-quantity') || '1', 10);

    if (!variantId) return;

    addBtn.disabled = true;
    addBtn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: qty }] })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      addBtn.textContent = 'Added!';
      updateCartCount();
      setTimeout(function() {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Cart';
        openCart();
        refreshCartDrawer();
      }, 800);
    })
    .catch(function() {
      addBtn.disabled = false;
      addBtn.textContent = 'Add to Cart';
    });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var counts = document.querySelectorAll('.site-header__cart-count');
        counts.forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var itemsContainer = document.querySelector('.cart-drawer__items');
        var totalEl = document.querySelector('.cart-drawer__total .amount');
        if (!itemsContainer) return;

        if (cart.items.length === 0) {
          itemsContainer.innerHTML = '<p style="text-align:center;color:var(--text-muted);padding:2rem 0;">Your cart is empty</p>';
        } else {
          var html = '';
          cart.items.forEach(function(item) {
            html += '<div style="display:flex;gap:1rem;margin-bottom:1rem;padding-bottom:1rem;border-bottom:1px solid var(--border-color);">';
            html += '<img src="' + item.image + '" alt="' + item.title + '" style="width:60px;height:60px;object-fit:cover;border-radius:var(--radius);">';
            html += '<div style="flex:1;"><div style="font-weight:600;font-size:0.875rem;">' + item.title + '</div>';
            html += '<div style="font-size:0.75rem;color:var(--text-muted);">Qty: ' + item.quantity + '</div>';
            html += '<div style="color:var(--teal);font-weight:700;">$' + (item.final_line_price / 100).toFixed(2) + '</div></div></div>';
          });
          itemsContainer.innerHTML = html;
        }
        if (totalEl) totalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
      });
  }

  // ---------- Intersection Observer for Animations ----------
  var animatedEls = document.querySelectorAll('[data-animate]');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in-up');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    animatedEls.forEach(function(el) { observer.observe(el); });
  }

  // Init cart count on page load
  updateCartCount();

})();
